import {
    Phase,
    PhaseType,
    SubscriptionOffers,
} from '@sxm-de/dev-kits/web-sdk/types';

export function getPhaseByType(
    type: PhaseType,
    offers: SubscriptionOffers,
): {
    offerId: string;
    phase: Phase;
    productIdMain: string;
} | null {
    // TODO: should we check currentPhase?
    const active = offers?.active.phases.find((phase) => phase.type === type);
    if (active) {
        const productIdMain =
            offers.active.products.find(({ productType }) => productType.main)
                ?.id || '';
        return {
            offerId: offers.active.id,
            phase: active,
            productIdMain,
        };
    }
    const pending = offers?.pending?.phases.find(
        (phase) => phase.type === type,
    );
    if (pending) {
        const productIdMain =
            offers.pending.products.find(({ productType }) => productType.main)
                ?.id || '';
        return {
            offerId: offers.pending.id,
            phase: pending,
            productIdMain,
        };
    }
    return null;
}
